<script setup lang="ts">
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineProps({
  title: null,
  open: { type: Boolean }
});
defineEmits(["update:title", "update:open"]);
const { open } = __MACROS_useVModel("title", "open")

const loading = ref(false)

function show() {
  open.value = true
}

function hide() {
  open.value = false
  loading.value = false
}
</script>

<template>
  <button class="self-center px-5 py-2.5 sb-button" @click="show">
    Modal auf
  </button>
  <Transition>
    <!-- Modal main -->
    <div v-show="open" class="modal-main-backgound">
      <div class="modal-main-box">
        <!-- Modal content -->
        <div class="modal-content">
          <div v-if="loading" class="backdrop z-19" />
          <div v-if="loading" class="float absolute left-a z-20 h-full w-full flex items-center justify-center text-center">
            <div class="circle-loader z-20 h-30 w-30" />
          </div>

          <!-- Modal header -->
          <div class="modal-header">
            <h3 v-if="title" class="text-xl font-semibold dark:text-white">
              {{ title }}
            </h3>
            <button type="button" class="modal-header-close" :disabled="loading" @click="hide">
              <div class="h-5 w-5" i-mdi-close />
              <span class="sr-only">Schließen</span>
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <div class="flex flex-col">
              <slot name="body" />
            </div>
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">
            <div class="flex justify-end">
              <button class="self-center px-5 py-2.5 sb-button" @click="hide">
                Modal schließen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>
